import api from "../../services/api";

const APIS = {
  COMPANY_LIST_DATA: "/Companies",
  COMPANY_EDIT: "/Companies",
  LOCATION_EDIT: "/Location/edit-location",
  ADD_COMPANY: "/Companies",
  ADD_LOCATION: "/Location",
  LOCATIONS_BY_COMPANY: "/Location/locations-by-company",
  CUSTOMER_LIST_DATA: "/Users/all-customers",
  CUSTOMER_EDIT: "/Users/updUser",
  APPROVE_USER: "/Users/approve",
  SAVE_REGISTERED_USER_BY_ADMIN: "/Users/saveregistereduser-by-admin",
  GET_REGISTERED_USER_BY_EMAIL: "/Users/get-registered-user-by-email",
  ADD_CUSTOMER: "/Users/add-customer",
  ADD_SAMPLES_TO_CUSTOMER: "/Sample/addsampleforcustomer",
  SALES_REPRESENTATIVE_LIST: "/Users/fieldstaff-names",
  SALES_REPRESENTATIVE: "/Users/sales-representative",
  COUNTRIES_WITH_STATE_LIST: "/Location/countries-with-states",
  PRODUCT_TYPE_DATA: "/ProductTypes",
  SPECIES_DATA: "/Species",
  UNITS_DATA: "/Units",
  GET_PRODUCT_TRADES: "/ProductTypes/getproducttrades",
  GET_PRODUCTS_BY_TRADE_ID: "/ProductTypes/getproductsbytradeid",
  GET_FEED_TYPE_BY_TRADE_AND_PRODUCT: "/ProductTypes/getfeedtypebytradeandproduct",
  GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED: "/ProductTypes/getspeciesbytradeandproductandfeed",
  GET_PRODUCT_CONFIGURATION: "/ProductTypes/getproductConfiguration",
  LOCATION_BY_LOCATIONID: "/Location/locationId"
};

export const getCompanyListData = async (params) => {
  try {
    const response = await api.get(APIS.COMPANY_LIST_DATA, { params });
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const getCountriesWithStates = async () => {
  try {
    const response = await api.get(APIS.COUNTRIES_WITH_STATE_LIST);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const getSalesRepData = async () => {
  try {
    const response = await api.get(APIS.SALES_REPRESENTATIVE_LIST);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const getLocationById = async (locationId) => {
  try {
     const response = await api.get(`${APIS.LOCATION_BY_LOCATIONID}/${locationId}`);
  return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSalesRepresentativeNameByLocationId = async (locationId) => {
  try {
    const response = await api.get(`${APIS.SALES_REPRESENTATIVE}/${locationId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const editCompanyData = async (payload) => {
  try {
    const response = await api.put(APIS.COMPANY_EDIT, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const editLocationData = async (payload) => {
  try {
    const response = await api.put(APIS.LOCATION_EDIT, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const addCompanyData = async (payload) => {
  try {
    const response = await api.post(APIS.ADD_COMPANY, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const addLocationData = async (payload) => {
  try {
    const response = await api.post(APIS.ADD_LOCATION, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const getLocationsByCompany = async (companyId) => {
  try {
    const response = await api.get(`${APIS.LOCATIONS_BY_COMPANY}/${companyId}`);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const getCustomerListData = async (params) => {
  try {
    const response = await api.get(APIS.CUSTOMER_LIST_DATA, { params });
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const addCustomerData = async (payload) => {
  try {
    const response = await api.post(APIS.ADD_CUSTOMER, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const approveUser = async (customerId, active) => {
  try {
    const res = await api.post(
      `${APIS.APPROVE_USER}/${encodeURIComponent(customerId)}/${active}`
    );
    return { success: true, data: res.data };
  } catch (error) {

    return { success: false, error };
  }
};

export const addSamplesToCustomer = async (payload) => {
  try {
    const response = await api.post(APIS.ADD_SAMPLES_TO_CUSTOMER, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const getSpeciesData = async () => {
  try {
    const response = await api.get(APIS.SPECIES_DATA);
    return formatSpecies(response.data);
  } catch (error) {

    throw error;
  }
};

export const getProductTypeData = async () => {
  try {
    const response = await api.get(APIS.PRODUCT_TYPE_DATA);
    return formatProductTypes(response.data);
  } catch (error) {

    throw error;
  }
};

export const getUnitsData = async () => {
  try {
    const response = await api.get(APIS.UNITS_DATA);
    return response.data.map(unit => ({
      id: unit.unitId,
      unitId: unit.unitId,
      name: unit.name,
      description: unit.description,
      isActive: unit.isActive
    }));
  } catch (error) {

    throw error;
  }
};

export const getProductTrades = async () => {
  try {
    const response = await api.get(APIS.GET_PRODUCT_TRADES);

    if (!response.data || !Array.isArray(response.data)) {

      return [];
    }

    const formattedTrades = response.data
      .filter(trade => trade && trade.productTradeNameId && trade.productTradeName)
      .map(trade => ({
        id: trade.productTradeNameId,
        productTradeNameId: trade.productTradeNameId,
        name: trade.productTradeName,
        productTradeName: trade.productTradeName,
        isActive: trade.isActive ?? true
      }));

    return formattedTrades;
  } catch (error) {

    return [];
  }
};

export const getProductsByTradeId = async (productTradeId) => {
  try {

    if (!productTradeId || isNaN(productTradeId)) {

      return [];
    }

    let response;
    try {
      response = await api.post(`${APIS.GET_PRODUCTS_BY_TRADE_ID}?ProductTradeId=${productTradeId}`);
      if (response.data && Array.isArray(response.data)) {
        return response.data.filter(type => type && type.productTypeId && type.name);
      }
    } catch (getError) {

      response = await api.post(`${APIS.GET_PRODUCTS_BY_TRADE_ID}?ProductTradeId=${productTradeId}`, {}, {
        headers: { 'Content-Type': 'application/json' }
      });
    }

    if (!response.data || !Array.isArray(response.data)) {
      return [];
    }

    return response.data.filter(type => type && type.productTypeId && type.name);
  } catch (error) {

    return [];
  }
};

export const getFeedTypeByTradeAndProduct = async (productTradeId, productTypeId) => {
  try {

    if (!productTradeId || !productTypeId || isNaN(productTradeId) || isNaN(productTypeId)) {

      return [];
    }

    let response;
    try {
      response = await api.post(`${APIS.GET_FEED_TYPE_BY_TRADE_AND_PRODUCT}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}`);
      if (response.data && Array.isArray(response.data)) {
        return response.data.filter(feed => feed && feed.feedTypeId && feed.feedTypeName);
      }
    } catch (getError) {

      response = await api.post(`${APIS.GET_FEED_TYPE_BY_TRADE_AND_PRODUCT}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}`, {}, {
        headers: { 'Content-Type': 'application/json' }
      });
    }

    if (!response.data || !Array.isArray(response.data)) {
      return [];
    }

    return response.data.filter(feed => feed && feed.feedTypeId && feed.feedTypeName);
  } catch (error) {

    return [];
  }
};

export const getSpeciesByTradeAndProductAndFeed = async (productTradeId, productTypeId, feedTypeId) => {
  try {

    if (!productTradeId || !productTypeId || !feedTypeId ||
        isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId)) {

      return [];
    }

    let response;
    try {
      response = await api.post(`${APIS.GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}`);
      if (response.data && Array.isArray(response.data)) {
        return response.data.filter(s => s && s.speciesId && s.speciesName);
      }
    } catch (getError) {

      response = await api.post(`${APIS.GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}`, {}, {
        headers: { 'Content-Type': 'application/json' }
      });
    }

    if (!response.data || !Array.isArray(response.data)) {
      return [];
    }

    return response.data.filter(s => s && s.speciesId && s.speciesName);
  } catch (error) {

    return [];
  }
};

export const getProductConfiguration = async (productTradeId, productTypeId, feedTypeId, speciesId) => {
  try {

    if (!productTradeId || !productTypeId || !feedTypeId || !speciesId ||
        isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId) || isNaN(speciesId)) {

      return {};
    }

    const apiUrl = `${APIS.GET_PRODUCT_CONFIGURATION}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}&speciesId=${speciesId}`;

    let response;

    try {

      response = await api.post(apiUrl);

    } catch (getError) {

      try {
        response = await api.post(apiUrl, {}, {
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });

      } catch (postError) {

        throw postError;
      }
    }

    if (response.data) {

      return response.data;
    } else {

      return {};
    }

  } catch (error) {

    return {};
  }
};

export const saveRegisteredUserByAdmin = async (userData) => {
  try {
    const requestBody = {
      companyName: userData.companyName,
      locationName: userData.locationName,
      address: userData.address,
      country: userData.country,
      state: userData.state,
      city: userData.city,
      zipCode: userData.zipCode,
      phone: userData.phone,
      fax: userData.fax || "",
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email?.trim().toLowerCase() || "",
      salesRep: userData.salesRep,
      companyId: userData.companyId || 0,
      locationId: userData.locationId || 0,
      sendAlertTo: userData.sendAlertTo || null,
      customerId: userData.customerId || 0
    };

    const res = await api.post(APIS.SAVE_REGISTERED_USER_BY_ADMIN, requestBody);
    return {
      success: true,
      data: res.data
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || "Save operation failed"
    };
  }
};

export const getRegisteredUserByEmail = async (email) => {
  try {
    const res = await api.get(`${APIS.GET_REGISTERED_USER_BY_EMAIL}?email=${encodeURIComponent(email?.trim().toLowerCase() || "")}`);
    return res.data;
  } catch (error) {

    throw error;
  }
};

export const editCustomerData = async (payload) => {
  try {
    const response = await api.put(APIS.CUSTOMER_EDIT, payload);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const formatProductTypes = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map(product => ({
    id: product.productTypeId,
    productTypeId: product.productTypeId,
    name: product.name,
    description: product.description,
    minLevel: product.minLevel,
    maxLevel: product.maxLevel,
    isActive: product.isActive,
    locationId: product.locationId
  }));
};

export const formatSpecies = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map(species => ({
    id: species.speciesId,
    speciesId: species.speciesId,
    name: species.name || species.speciesName,
    description: species.description,
    isActive: species.isActive
  }));
};

export const formatProductTrades = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map(trade => ({
    id: trade.productTradeNameId,
    productTradeNameId: trade.productTradeNameId,
    productTradeName: trade.productTradeName,
    name: trade.productTradeName,
    isActive: trade.isActive
  }));
};

export const formatFeedTypes = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map(feed => ({
    id: feed.feedTypeId,
    feedTypeId: feed.feedTypeId,
    feedTypeName: feed.feedTypeName,
    name: feed.feedTypeName,
    isActive: feed.isActive
  }));
};

export const formatUserDetails = (data) => {
  return {
    email: data.email || '',
    name: data.name || '',
    roleName: Array.isArray(data.roleName) ? data.roleName : [],
    companyName: data.companyName || '',
    companyId: data.companyId,
    locationName: data.locationName || '',
    locationID: data.locationID,
    salesRep: data.salesRep || '',
    salesRepId: data.salesRepId || 0
  };
};